import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { StatsSection } from '../common/stats-section';
import { useStatComparisonNavSync } from './hooks/use-stat-comparison-nav-sync';
import { CategoryNavItem, SeasonNavItem } from './components/nav-items';
import { useCompetitionNavigationOptions } from '../../../../../../common/react/hooks/use-competition-navigation-options';
import {
    statComparisonDataTypeSelector,
    statComparisonNavSelector
} from '../../../../store/js/modules/statspro/stat-comparison/selectors';
import {
    BenchmarkingLegend,
    BenchmarkingExplainer
} from '../../../../../../common/react/components/benchmarking';
import { DataTypeToggle, Heading } from './components/header';
import { StatComparisonMain } from './components/StatComparisonMain';
import { playersSelector } from '../../../../store/js/modules/statspro/player-comparison/selectors';
import classNames from 'classnames';
import { BenchmarkingPlaceholder } from '../../../../../../common/react/components/benchmarking/BenchmarkingPlaceholder';

export const StatComparison = ({ title }) => {
    const nav = useSelector(statComparisonNavSelector);
    const dataType = useSelector(statComparisonDataTypeSelector);
    const options = useCompetitionNavigationOptions(nav);
    useStatComparisonNavSync(options);
    const playerIds = useSelector(playersSelector);

    return (
        <div
            className={classNames(
                'fade-in-on-load fade-in-on-load--stats widget--stats',
                {
                    'is-loaded': playerIds[1] || playerIds[2]
                }
            )}
        >
        {playerIds[1] || playerIds[2] ? (
            <StatsSection.Main>
                <StatsSection.Heading isSmallModifier={true}>
                    {title}
                </StatsSection.Heading>
                <StatsSection.Nav>
                    <StatsSection.NavItems>
                        <CategoryNavItem />
                        <SeasonNavItem />
                    </StatsSection.NavItems>
                </StatsSection.Nav>
                <StatsSection.Content>
                    <StatsSection.ContentHeader>
                        <StatsSection.ContentHeaderHeading>
                            <Heading />
                        </StatsSection.ContentHeaderHeading>
                        <StatsSection.ContentHeaderOptions>
                            <DataTypeToggle />
                        </StatsSection.ContentHeaderOptions>
                        {(dataType.type === 'averages' ||
                            dataType.type === 'benchmarkedAverages') && (
                            <StatsSection.ContentHeaderBelow>
                                {(dataType.type === 'averages' ||
                                    dataType.type ===
                                        'benchmarkedAverages') && (
                                    <BenchmarkingLegend />
                                )}
                                {(dataType.type === 'averages' ||
                                    dataType.type ===
                                    'benchmarkedAverages') && (
                                    <BenchmarkingExplainer />
                                )}
                            </StatsSection.ContentHeaderBelow>
                        )}
                        {(dataType.type === 'totals' ||
                            dataType.type === 'benchmarkedTotals') && (
                            <StatsSection.ContentHeaderBelow
                                isSingleModifier={true}
                            >
                                {(dataType.type === 'totals' ||
                                    dataType.type === 'benchmarkedTotals') && (
                                    <BenchmarkingPlaceholder />
                                )}
                            </StatsSection.ContentHeaderBelow>
                        )}
                    </StatsSection.ContentHeader>
                    <StatsSection.ContentBody>
                        <StatComparisonMain playerIds={playerIds} />
                    </StatsSection.ContentBody>
                </StatsSection.Content>
            </StatsSection.Main>
        ) : null}
        </div>
    );
};

StatComparison.propTypes = {
    title: PropTypes.string.isRequired
};
